import { gql } from '@apollo/client';
import { PARKING_SESSION_FIELDS } from '../fields/parkingSessionFields';

export const CREATE_PARKING_SESSION = gql`
  ${PARKING_SESSION_FIELDS}
  mutation createParkingSession($input: CreateParkingSessionInput!) {
    createParkingSession(input: $input) {
      ...ParkingSessionFields
    }
  }
`;
